<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/56/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/56/title-1.png" alt="" />
                    <div class="content">
                        户籍或工作单位注册地在郫都的区各级党政机关、企事业单位、社会组织中从事专业社会工作的全职人员。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/56/title-2.png" alt="" />
                    <div class="content">
                        在郫都区登记报名，参加社会工作职业资格考试并取得成都市社工员、助理社会工作师、社会工作师、高级社会工作师等证书并继续在郫都区内从事专业社会工作满一年。
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/56/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 确定薪酬待遇</div>
                            助理社会工作师薪酬标准参照成都市年度平均工资公告中“卫生和社会工作”的平均工资，中级社会工作师上浮不低于20%，高级社会工作师上浮不低于50%。机关、事业单位及群团组织等开发设置社工岗位的社工人才，其薪酬参照相应职级的工资标准执行。承接政府购买社会工作服务项目的合约中明确用于支付薪酬的资金不低于60%。
                        </div>
                        <div class="des">
                            <div class="title">二. 加大培训力度</div>
                            逐年增加社会工作服务项目、薪酬待遇、社工人才培养和继续教育、考前培训、民办社工服务机构培育发展、行业规范管理等方面的财政投入。免费开展继续教育、专题培训等，给予参加社会工作职业资格水平考试考前培训费50%的补助。
                        </div>
                        <div class="des">
                            <div class="title">三. 开展表扬奖励</div>
                            对获得国家级社会工作领军人才的给予一次性奖励10万元，对获得省级社会工作人才表彰的给予一次性奖励5万元，对获得市级、区级等其他表彰表扬的给予适当奖励。鼓励用人单位对单位内部优秀社工人才开展多种形式的表扬奖励。对在我区登记报名，参加考试并取得成都市社工员、助理社会工作师、社会工作师、高级社会工作师等证书并继续在我区内从事专业社会工作满一年以上的人员分别给予400、800、1500、3000元的一次性奖励。
                        </div>
                        <div class="des">
                            <div class="title">四.提高职业地位</div>
                            把政治素质好、业务水平高的社工人才吸纳进党员干部队伍，选拔进基层领导班子，推荐有突出贡献的社工人才作为党代表、人大代表、政协委员人选。鼓励符合条件的社工人才通过选举进入村（社区）党组织、村（居）民自治组织。在选拔申报享受政府特殊津贴人员、优秀专家等充分考虑符合条件的社工人才。将社会工作优秀人才、成都市民政局“社会工作专家库”特聘专家等高层次人才纳入郫都区急需紧缺和重点人才引进范围，多形式多渠道开展引进工作，并按照有关政策在解决住房、子女就学、配偶就业等方面给予扶持和优惠。
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/25/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                区民政局印发申报通知
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                申报人根据通知在申报时限内提交相应材料
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                区民政局核实资料是否真实、完整
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                发放激励资金
                            </div>
                        </div>
                    </div>
                </div>

                <div class="contact">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-87888910">028-87888910</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市郫都区民政局
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/56/code.png" />
                    <img class="text" src="../assets/imgs/56/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .des {
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4.5rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.24rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
